import { Tag } from "@lezer/highlight";

export const CommandLinkTag = Tag.define();
export const CommandLinkNameTag = Tag.define();
export const CommandLinkArgsTag = Tag.define();
export const WikiLinkTag = Tag.define();
export const WikiLinkPageTag = Tag.define();
export const CodeInfoTag = Tag.define();
export const CommentTag = Tag.define();
export const CommentMarkerTag = Tag.define();
export const BulletList = Tag.define();
export const OrderedList = Tag.define();
export const Highlight = Tag.define();
export const HorizontalRuleTag = Tag.define();

export const AttributeTag = Tag.define();
export const AttributeNameTag = Tag.define();
export const AttributeValueTag = Tag.define();

export const NamedAnchorTag = Tag.define();

export const TaskTag = Tag.define();
export const TaskMarkTag = Tag.define();
export const TaskStateTag = Tag.define();
export const TaskDeadlineTag = Tag.define();

export const HashtagTag = Tag.define();
export const NakedURLTag = Tag.define();

export const DirectiveMarkTag = Tag.define();
export const DirectiveTag = Tag.define();
